// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"364f668d","845":"4caa152e"}[chunkId] + ".chunk.js";
};